import { render, staticRenderFns } from "./ImportResourceFileUpload.vue?vue&type=template&id=389fd37a&scoped=true&"
import script from "./ImportResourceFileUpload.vue?vue&type=script&lang=ts&"
export * from "./ImportResourceFileUpload.vue?vue&type=script&lang=ts&"
import style0 from "./ImportResourceFileUpload.vue?vue&type=style&index=0&id=389fd37a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389fd37a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VAlert,VBtn,VFileInput,VForm})
